module.exports = {
  base: {
    api: {
      getAllModelLines: '/dealercenter/rest/modelLine/allModelLines',
      getModelTrims: '/dealercenter/rest/modelLine/modelLineTrims',
      getTrimOffers: '/dealercenter/rest/offers',
      getTrimIncentives: '/dealercenter/rest/offers/incentive',
      getDMA: '/dealercenter/rest/dma/by',
      getPaymentOptions: '/dealercenter/rest/offers/allinone',
      getBestOffers: '/dealercenter/rest/offers/bestOffers',
      getDealersByZip: '/dealercenter/rest/listDealersByZipCode',
    },
    headCssLinks: [
      '/styleguide/css/nna-infiniti-styleguide.min.css',
      '/webfonts/fonts/infiniti-thin.css',
      '/webfonts/fonts/infiniti-metapro.css'
    ],
    heliosHeadCssLinks: [],
    appBuild: 'dist/infiniti/lease-finance-payment-calculator/',
    cookies: {
      zipCode: 'ZipCode',
      visitorId: 'visitorID'
    }
  },
  languages: {
    en: {
      appBuild: 'dist/infiniti/lease-finance-payment-calculator',
      landingPage: '/lease-finance-payment-calculator',
      headJsImports: [
        '/libs/api/external/dtm.js'
      ],
      heliosHeadJsImports: [],
      heliosLogin: '',
      heliosLiveChatURL: '',
      heliosPageTitle: '',
      headerLoaded: '',
      footerLoaded: '',
      bodyInnerBeforeJSImports: [
        '/content/infiniti/us/en/global/responsive-header/_jcr_content/par/responsive_header.js.html',
        '/styleguide/js/global-navigation-full.min.js'
      ],
      bodyInnerAfterJSImports: [
        '/content/infiniti/us/en/global/responsive-footer/_jcr_content/par/responsive_footer.js.html'
      ]
    }
  },
  slots: {
    dev: {
      protocol: 'https:',
      rootPath: 'localhost:3000',
      brandPath: 'http://infinitiusa-validation-1.criticalmass.com/',
    },
    validation: {
      protocol: 'https:',
      rootPath: '',
      brandPath: '',
    },
    uat: {
      protocol: 'https:',
      rootPath: '',
      brandPath: '',
    },
    production: {
      protocol: 'https:',
      rootPath: '',
      brandPath: '',
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./config/brand/nna/infiniti.js
 ** module id = 257
 ** module chunks = 0
 **/